"use strict";
/**
 * @file Created on 20.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var WindowItemSimulation_1 = require("../../../window/model/WindowItemSimulation");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NSimulationProductDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NSimulationProductDTO, _NotificationDoc_1$No);

  /**
   * @param productId
   * @param productName
   * @param productExternalId
   * @param simulation
   */
  function NSimulationProductDTO(productId, productName, productExternalId, simulation) {
    var _this;

    _classCallCheck(this, NSimulationProductDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NSimulationProductDTO).call(this));
    _this.productId = productId;
    _this.productName = productName;
    _this.productExternalId = productExternalId;
    _this.simulation = simulation;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NSimulationProductDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NSimulationProductDTO(mat.productId, mat.productName, mat.productExternalId, mat.simulation);
    }
  }]);

  return NSimulationProductDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NSimulationProductDTO = NSimulationProductDTO;

NSimulationProductDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NSimulationProductDTO.name);
  return {
    productId: builder.id('productId'),
    productName: builder.str('productName'),
    productExternalId: builder.str('productExternalId'),
    simulation: builder.obj('simulation', WindowItemSimulation_1.WindowItemSimulation.schema, function (mat) {
      return WindowItemSimulation_1.WindowItemSimulation.fromDataDict(mat);
    })
  };
}();